import React from 'react';
interface QuadrantProps {
    className: string;
    label: string;
    scale: number;
}

const Quadrant: React.FC<QuadrantProps> = ({ className, label, scale }) => {
    return (
        <div className={className}>
            <label
                style={{
                    transform: `scale(${1 / scale})`,
                    letterSpacing: `${1.26 / scale}px`,
                }}
            >
                {label}
            </label>
        </div>
    );
};

export default Quadrant;